export default __webpack_public_path__ + "img/web-default.ddf65159.png";